import { render, staticRenderFns } from "./CouponBanner.vue?vue&type=template&id=b2ea4bbc&scoped=true"
import script from "./CouponBanner.vue?vue&type=script&lang=js"
export * from "./CouponBanner.vue?vue&type=script&lang=js"
import style0 from "./CouponBanner.vue?vue&type=style&index=0&id=b2ea4bbc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b2ea4bbc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/fe/mewo-website-vue-kr/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b2ea4bbc')) {
      api.createRecord('b2ea4bbc', component.options)
    } else {
      api.reload('b2ea4bbc', component.options)
    }
    module.hot.accept("./CouponBanner.vue?vue&type=template&id=b2ea4bbc&scoped=true", function () {
      api.rerender('b2ea4bbc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/CouponBanner.vue"
export default component.exports